import React from 'react';
import { observer } from 'mobx-react';
import ConfirmModalCorporateDocs from '../../../../components/ConfirmModalCorporateDocs';
import { default as FileNameCorp } from '../CorporateDocument/components/FileName';
import { default as FileNameMulty } from '../CorporateDocument/components/FileNameMulty';
import { corparateDoc } from '../CorporateDocument';

import st from '../CorporateDocument/styles.module.scss';

const CorporateDocsConfirmModal = observer(() => {
  return (
    <ConfirmModalCorporateDocs title="Please double-check your datа before you submit">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: '32px',
        }}
      >
        {/* 1 - Certificate of Incorporation */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <h3>
            <b>Certificate of Incorporation or equivalent</b>
          </h3>

          <div className={st.confirmBlock}>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                File:
              </div>
              <div style={{ width: '654px' }}>
                {corparateDoc.values?.certificateOfIncorporationFile?.name
                  ?.length! > 0 && (
                  <FileNameCorp
                    fileName="certificateOfIncorporationFile"
                    clearFiles={() => {}}
                    needDel={false}
                  />
                )}

                {corparateDoc.values?.certificateOfIncorporationFile?.name
                  ?.length! === 0 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: '10px',
                    }}
                  >
                    -
                  </div>
                )}
              </div>
            </div>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                Comment:
              </div>
              <div style={{ paddingLeft: '10px' }}>
                {corparateDoc.values?.certificateOfIncorporationComment.length >
                0
                  ? corparateDoc.values?.certificateOfIncorporationComment
                  : '-'}
              </div>
            </div>
          </div>
        </div>

        {/* 2 - Certificate of registered address */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <h3>
            <b>
              Certificate of registered address, e.g. bank statement/ utility
              bill
            </b>
          </h3>

          <div className={st.confirmBlock}>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                File:
              </div>
              <div style={{ width: '654px' }}>
                {corparateDoc.values?.certificateOfRegisteredAddressFile?.name
                  ?.length! > 0 && (
                  <FileNameCorp
                    fileName="certificateOfRegisteredAddressFile"
                    clearFiles={() => {}}
                    needDel={false}
                  />
                )}
                {corparateDoc.values?.certificateOfRegisteredAddressFile?.name
                  ?.length! === 0 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: '10px',
                    }}
                  >
                    -
                  </div>
                )}
              </div>
            </div>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                Comment:
              </div>
              <div style={{ paddingLeft: '10px' }}>
                {corparateDoc.values?.certificateOfRegisteredAddressComment
                  .length > 0
                  ? corparateDoc.values?.certificateOfRegisteredAddressComment
                  : '-'}
              </div>
            </div>
          </div>
        </div>

        {/* 3 - Certificate of Directors */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <h3>
            <b>Certificate of Directors and Secretary or equivalent</b>
          </h3>

          <div className={st.confirmBlock}>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                File:
              </div>
              <div style={{ width: '654px' }}>
                {corparateDoc.values?.certificateOfDirectorsFile?.name
                  ?.length! > 0 && (
                  <FileNameCorp
                    fileName="certificateOfDirectorsFile"
                    clearFiles={() => {}}
                    needDel={false}
                  />
                )}
                {corparateDoc.values?.certificateOfDirectorsFile?.name
                  ?.length! === 0 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: '10px',
                    }}
                  >
                    -
                  </div>
                )}
              </div>
            </div>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                Comment:
              </div>
              <div style={{ paddingLeft: '10px' }}>
                {corparateDoc.values?.certificateOfDirectorsComment.length > 0
                  ? corparateDoc.values?.certificateOfDirectorsComment
                  : '-'}
              </div>
            </div>
          </div>
        </div>

        {/* 4 - Certificate of Shareholders */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <h3>
            <b>Certificate of Shareholders</b>
          </h3>

          <div className={st.confirmBlock}>
            {corparateDoc.values.certificateOfShareholdersFiles.length > 0 &&
              corparateDoc.values.certificateOfShareholdersFiles.map(
                (el, i) => (
                  <div className={st.row} key={i}>
                    <div style={{ width: '195px' }} className={st.cellleft}>
                      File:
                    </div>
                    <div style={{ width: '654px' }}>
                      <FileNameMulty
                        fileIndex={i}
                        clearFiles={() => {}}
                        needDel={false}
                      />
                    </div>
                  </div>
                ),
              )}

            {!corparateDoc.values.certificateOfShareholdersFiles.length && (
              <div className={st.row}>
                <div style={{ width: '250px' }} className={st.cellleft}>
                  File:
                </div>
                <div className={st.uploadedforConfirm}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: '10px',
                    }}
                  >
                    -
                  </div>
                </div>
              </div>
            )}

            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                Comment:
              </div>
              <div style={{ paddingLeft: '10px' }}>
                {corparateDoc.values?.certificateOfShareholdersComment.length >
                0
                  ? corparateDoc.values?.certificateOfShareholdersComment
                  : '-'}
              </div>
            </div>
          </div>
        </div>

        {/* 5 - Certificate of Good Standing */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <h3>
            <b>Certificate of Good Standing or equivalent</b>
          </h3>

          <div className={st.confirmBlock}>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                File:
              </div>
              <div style={{ width: '654px' }}>
                {corparateDoc.values?.certificateOfGoodStandingFile?.name
                  ?.length! > 0 && (
                  <FileNameCorp
                    fileName="certificateOfGoodStandingFile"
                    clearFiles={() => {}}
                    needDel={false}
                  />
                )}
                {corparateDoc.values?.certificateOfGoodStandingFile?.name
                  ?.length! === 0 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: '10px',
                    }}
                  >
                    -
                  </div>
                )}
              </div>
            </div>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                Comment:
              </div>
              <div style={{ paddingLeft: '10px' }}>
                {corparateDoc.values?.certificateOfGoodStandingComment.length >
                0
                  ? corparateDoc.values?.certificateOfGoodStandingComment
                  : '-'}
              </div>
            </div>
          </div>
        </div>

        {/* 6 - Memorandum and Articles */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <h3>
            <b>Memorandum and Articles of Association</b>
          </h3>

          <div className={st.confirmBlock}>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                File:
              </div>
              <div style={{ width: '654px' }}>
                {corparateDoc.values?.memorandumAndArticlesOfAssociationFile
                  ?.name?.length! > 0 && (
                  <FileNameCorp
                    fileName="memorandumAndArticlesOfAssociationFile"
                    clearFiles={() => {}}
                    needDel={false}
                  />
                )}
                {corparateDoc.values?.memorandumAndArticlesOfAssociationFile
                  ?.name?.length! === 0 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: '10px',
                    }}
                  >
                    -
                  </div>
                )}
              </div>
            </div>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                Comment:
              </div>
              <div style={{ paddingLeft: '10px' }}>
                {corparateDoc.values?.memorandumAndArticlesOfAssociationComment
                  .length > 0
                  ? corparateDoc.values
                      ?.memorandumAndArticlesOfAssociationComment
                  : '-'}
              </div>
            </div>
          </div>
        </div>

        {/* 7 - Latest Audited Financial Statement */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <h3>
            <b>Latest Audited Financial Statement or Management Accounts</b>
          </h3>

          <div className={st.confirmBlock}>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                File:
              </div>
              <div style={{ width: '654px' }}>
                {corparateDoc.values?.latestAuditedFinancialStatementFile?.name
                  ?.length! > 0 && (
                  <FileNameCorp
                    fileName="latestAuditedFinancialStatementFile"
                    clearFiles={() => {}}
                    needDel={false}
                  />
                )}
                {corparateDoc.values?.latestAuditedFinancialStatementFile?.name
                  ?.length! === 0 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      paddingLeft: '10px',
                    }}
                  >
                    -
                  </div>
                )}
              </div>
            </div>
            <div className={st.row}>
              <div style={{ width: '195px' }} className={st.cellleft}>
                Comment:
              </div>
              <div style={{ paddingLeft: '10px' }}>
                {corparateDoc.values?.latestAuditedFinancialStatementComment
                  .length > 0
                  ? corparateDoc.values?.latestAuditedFinancialStatementComment
                  : '-'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ConfirmModalCorporateDocs>
  );
});

export default CorporateDocsConfirmModal;
